export default "__VITE_ASSET__d003e2a9__"